<template>
  <transition :class="classes" :name="animate" mode="out-in" v-on="$listeners" v-bind="$attrs">
      <slot></slot>
    </transition>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-transition'

export default {
  name: 'wt-transition',
  props: {
    animate: {
      type: String,
      default: 'fade',
      validator (val) {
        console.log('val', val)
        return ['fade', 'fade-left', 'fade-right'].findIndex(item => item === val) > -1
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
.animate-build(@name){
  @{name}-enter-active,
  @{name}-leave-active{
    transition: opacity .15s
  }
  .@{name}-enter,
    .@{name}-leave-to {
      opacity: 0
    }
}

//fade
.animate-build(fade);

//fade-left
.animate-build(fade-left);
.fade-left-enter,
.fade-left-leave-to {
  transform:translateX(2em)
}

//fade-right
.animate-build(fade-right);
.fade-right-enter,
.fade-right-leave-to {
  transform:translateX(-2em)
}
</style>
